var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-management" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", closable: "" },
          on: { "tab-remove": _vm.removeTab },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "会员列表", name: "list", closable: false } },
            [
              _c("div", { staticClass: "search-area" }, [
                _c(
                  "div",
                  { staticClass: "search-content" },
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "search-form",
                        attrs: { inline: true, model: _vm.searchForm },
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入手机号",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.mobilePhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "mobilePhone", $$v)
                                },
                                expression: "searchForm.mobilePhone",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: "注册方式",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.registerType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "registerType",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.registerType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "点餐", value: "2" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "社交", value: "4" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "支付宝", value: "5" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "卡型", clearable: "" },
                                model: {
                                  value: _vm.searchForm.cardType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "cardType", $$v)
                                  },
                                  expression: "searchForm.cardType",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "全部", value: "" },
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.cardTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入卡号",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.cardNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "cardNo", $$v)
                                },
                                expression: "searchForm.cardNo",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "datetimerange",
                                "range-separator": "至",
                                "start-placeholder": "注册开始时间",
                                "end-placeholder": "注册结束时间",
                                format: "yyyy-MM-dd HH:mm:ss",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.regTimeRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "regTimeRange", $$v)
                                },
                                expression: "searchForm.regTimeRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("添加会员")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: { click: _vm.exportMembers },
                      },
                      [_vm._v("导出")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "用户ID",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "thirdUserId",
                      label: "POS用户ID",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.thirdUserId))]),
                            _vm._v(" "),
                            _vm.getChannelIcons(scope.row).length
                              ? _c(
                                  "div",
                                  { staticClass: "channel-icons" },
                                  _vm._l(
                                    _vm.getChannelIcons(scope.row),
                                    function (icon) {
                                      return _c(
                                        "el-tooltip",
                                        {
                                          key: icon.label,
                                          attrs: {
                                            content: icon.label,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "channel-icon",
                                            attrs: {
                                              src: icon.src,
                                              alt: icon.label,
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nickName",
                      label: "昵称",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userpic",
                      label: "头像",
                      align: "center",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-avatar", {
                              attrs: {
                                src: _vm.getAvatarUrl(scope.row.userpic),
                                size: "small",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardNo",
                      label: "卡号",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "mobilePhone",
                      label: "手机号",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "regionName",
                      label: "城市",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isWw",
                      label: "是否加企微",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(scope.row.isWw ? "是" : "否") +
                                "\n      "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "regTime",
                      label: "注册时间",
                      align: "center",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.formatTime(scope.row.regTime)) +
                                "\n      "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "registerType",
                      label: "注册来源",
                      align: "center",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.getRegisterTypeText(
                                    scope.row.registerType
                                  )
                                ) +
                                "\n      "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "money",
                      label: "余额",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bonus",
                      label: "积分",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "surplusCoupon",
                      label: "优惠券",
                      align: "center",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cardTypeName",
                      label: "卡类型",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "growthValue",
                      label: "成长值",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "微信信息",
                      align: "center",
                      "min-width": "350",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _c("div", { staticClass: "wechat-info-item" }, [
                                _vm._v(
                                  "\n        点餐：" +
                                    _vm._s(
                                      _vm.getOpenId(
                                        scope.row.openIds,
                                        "DELI"
                                      ) ||
                                        _vm.getOpenId(
                                          scope.row.openIds,
                                          "GAGAX"
                                        )
                                    ) +
                                    "\n        "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "unbind-btn",
                                    on: {
                                      click: function ($event) {
                                        _vm.unbindOpenId(
                                          _vm.getOpenId(
                                            scope.row.openIds,
                                            "DELI"
                                          ) ||
                                            _vm.getOpenId(
                                              scope.row.openIds,
                                              "GAGAX"
                                            ),
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("[-]")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wechat-info-item" }, [
                                _vm._v(
                                  "\n        社交：" +
                                    _vm._s(
                                      _vm.getOpenId(scope.row.openIds, "GAGAS")
                                    ) +
                                    "\n        "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "unbind-btn",
                                    on: {
                                      click: function ($event) {
                                        _vm.unbindOpenId(
                                          _vm.getOpenId(
                                            scope.row.openIds,
                                            "GAGAS"
                                          ),
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("[-]")]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "wechat-info-item" }, [
                                _vm._v(
                                  "\n        支付宝：" +
                                    _vm._s(
                                      _vm.getOpenId(scope.row.openIds, "ALIX")
                                    ) +
                                    "\n        "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "unbind-btn",
                                    on: {
                                      click: function ($event) {
                                        _vm.unbindOpenId(
                                          _vm.getOpenId(
                                            scope.row.openIds,
                                            "ALIX"
                                          ),
                                          scope.row.id
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("[-]")]
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "labels",
                      label: "标签",
                      align: "center",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastLoginTime",
                      label: "最近登录",
                      align: "center",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.formatTime(scope.row.lastLoginTime)
                                ) +
                                "\n      "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: "操作",
                      align: "center",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref:
                                  "popover-" +
                                  (scope.row.id || scope.row.userId),
                                attrs: {
                                  placement: "bottom",
                                  width: "200",
                                  trigger: "click",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "operation-buttons-beautify" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRecharge(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("充值")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleCouponDetail(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("券信息")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOrder(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("订单")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDetails(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("明细")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddress(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("地址")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn warning",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSync(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("同步")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn warning",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUnbind(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("解绑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleLog(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("日志")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn danger",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "op-btn",
                                        attrs: { size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSummary(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("汇总")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      type: "primary",
                                      size: "small",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v("\n            操作菜单 "),
                                    _c("i", {
                                      staticClass: "el-icon-arrow-down",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-area" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.editTabs, function (item) {
            return _c(
              "el-tab-pane",
              { key: item.name, attrs: { label: item.title, name: item.name } },
              [
                item.type === "add" || item.type === "edit"
                  ? _c("member-form", {
                      attrs: {
                        type: item.type,
                        "member-data": item.memberData,
                      },
                      on: {
                        submit: _vm.onSubmit,
                        cancel: function () {
                          return _vm.removeTab(item.name)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "recharge"
                  ? _c("member-recharge-record", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "coupon"
                  ? _c("coupon-management", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "exchange"
                  ? _c("exchange-list", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "order"
                  ? _c("member-order", {
                      attrs: { "member-data": item.memberData },
                      on: { "open-order-detail": _vm.handleOpenOrderDetail },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "orderDetail"
                  ? _c("order-detail", {
                      attrs: { "order-data": item.orderData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "accountDetail"
                  ? _c("account-change-detail", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "address"
                  ? _c("member-address", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "log"
                  ? _c("member-log", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "summary"
                  ? _c("member-summary", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
                _vm._v(" "),
                item.type === "couponDetail"
                  ? _c("coupon-detail", {
                      attrs: { "member-data": item.memberData },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }